// P24 (démo du 09/10, D4) — la mémoire de « Barres | Structure » (session, par graphique),
// hors du fichier du composant : un module de composant n'exporte que des composants
// (rechargement à chaud de Vite).
import { useCallback, useState } from 'react'

export type FormeRepartition = 'barres' | 'structure'

const PREFIXE = 'obs2:forme:'

function lire(cle: string): FormeRepartition {
  try {
    return sessionStorage.getItem(PREFIXE + cle) === 'structure' ? 'structure' : 'barres'
  } catch {
    return 'barres'
  }
}

/** Mémorise « barres / structure » d'UN graphique pour la session (`memoriser = false` sur la
 *  page d'un lien partagé : rien n'est écrit chez le visiteur). */
export function useFormeRepartition(cle: string, memoriser = true)
  : [FormeRepartition, (f: FormeRepartition) => void] {
  // Le choix est rangé AVEC sa clé : quand le composant passe à un autre graphique, l'état
  // d'avant ne vaut plus et on relit la mémoire de celui-ci (sans effet ni rendu en cascade).
  const [etat, setEtat] = useState<{ cle: string; forme: FormeRepartition }>(
    () => ({ cle, forme: memoriser ? lire(cle) : 'barres' }))
  const forme = etat.cle === cle ? etat.forme : (memoriser ? lire(cle) : 'barres')
  const choisir = useCallback((f: FormeRepartition) => {
    setEtat({ cle, forme: f })
    if (!memoriser) return
    try { sessionStorage.setItem(PREFIXE + cle, f) } catch { /* stockage refusé : sans mémoire */ }
  }, [cle, memoriser])
  return [forme, choisir]
}
